// @flow
import type {
  AssetMigrateOperation,
} from '../types'

export default ({
  operations: [],
}: {
  operations: Array<AssetMigrateOperation>,
})
